import { Container } from "react-bootstrap"

const Contact = () => {
  return (
    <div className="section bg-dark text-light d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <Container className="text-center">
        <h2 className="fw-bold mb-4">Contact Me</h2>
        <div className="d-flex justify-content-center gap-4 fs-2">
          <a
            href="https://www.linkedin.com/in/donovan-monteiro-5131b1148/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-light contact-icon"
          >
            <i className="bi bi-linkedin"></i>
          </a>
          <a
            href="https://github.com/don0716"
            target="_blank"
            rel="noopener noreferrer"
            className="text-light contact-icon"
          >
            <i className="bi bi-github"></i>
          </a>
          <a href="mailto:donmonteiro16@gmail.com" className="text-light contact-icon">
            <i className="bi bi-envelope-fill"></i>
          </a>
        </div>
        
      </Container>
    </div>
  )
}

export default Contact
